import cloneDeep from 'lodash/cloneDeep';
import lodashGet from 'lodash/get';
import { apis, inWindow } from '@/config';
import { api } from '@/api/api';
import { SUB_ACCOUNT_ERRCODE_MAPS } from '../_login/login_const';
import { util, wait } from '@/api/util';
import { ErrMsgCodeMap } from '@/api/errMap';
import { corpMailTransformResponse } from '../mail/corp_mail_utils';
import { checkMasterInfo } from '@mail/jmail';
const loginingMailMap = new Map();
let isDeleteingLocalSubAccounts = false;
const defaultHeader = {
    'Qiye-Header': 'sirius',
};
const defaultParams = {
    product: 'sirius',
};
const accountItemFilterName = 'accountItemFilterName';
const APP_SIDEBAR_DOCK_ACCOUNT_LIST = 'app_sidebar_dock_account_list';
let subAccountsCache = [];
let sharedAccountInfoCache = null;
let subAccountIdToAgentCache = {};
const accountInfoCache = {};
class AccountApiImp {
    constructor() {
        this.contactApi = api.requireLogicalApi(apis.contactApiImpl);
        this.loginApi = api.requireLogicalApi(apis.loginApiImpl);
        this.performanceApi = api.requireLogicalApi(apis.performanceImpl);
        this.dbName = 'account';
        this.tableName = 'account';
        this.subAccountTableName = 'subAccount';
        this.domainTableName = 'domain';
        this.infoTableName = 'accountInfo';
        this.secCertTableName = 'secCertInfo';
        this.encryptedPwdHead = 'encrypted:[';
        this.encryptedPwdTail = ']';
        this.subAccountDataCompleteKey = 'sub_account_data_complete';
        this.isInited = false;
        this.initModule = new Set();
        this.isSyncAccountInfo = false;
        this.requestAccountInfoList = [];
        this._ownDomainSetCache = new Map();
        this._ownDomainSetInflight = new Map();
        this.isSubAccountInited = false;
        this.sideBarDockAccountList = {};
        this.cache = { isAccount: undefined };
        this.updateAccountRefreshTokenHandle = {
            eventPeriod: 'extLong',
            handler: ob => {
                if (ob.seq > 1 && ob.seq % 24 === AccountApiImp.RndSyncRate) {
                    const currentUser = this.systemApi.getCurrentUser();
                    if (currentUser) {
                        this.doUpdateAccountRefreshToken();
                        this.productAuthApi.saveAuthConfigFromNet();
                    }
                }
            },
            id: 'refreshTokenAndUpdateAuthConfig',
            seq: 0,
        };
        this.currentDomainList = [];
        this.name = apis.accountApiImpl;
        this.eventApi = api.getEventApi();
        this.systemApi = api.getSystemApi();
        this.storeApi = api.getDataStoreApi();
        this.httpApi = api.getDataTransApi();
        this.DBApi = api.getNewDBApi();
        this.mailConfigApi = api.requireLogicalApi(apis.mailConfApiImpl);
        this.dataTrackApi = api.requireLogicalApi(apis.dataTrackerApiImp);
        this.productAuthApi = api.requireLogicalApi(apis.productAuthApiImpl);
        this.mailApi = api.requireLogicalApi(apis.mailApiImpl);
        this.loggerApi = api.requireLogicalApi(apis.loggerApiImpl);
        this.subAccounts = [];
        this.syncSubAccountTimer = null;
    }
    getSid(email) {
        const currentUser = this.systemApi.getCurrentUser(email);
        return (currentUser === null || currentUser === void 0 ? void 0 : currentUser.sessionId) || '';
    }
    async doSyncDomainShareList() {
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        if (isCorpMail) {
            return {};
        }
        const isMainAccount = !this.getIsAccountBg();
        if (!isMainAccount) {
            return {};
        }
        const res = (await this.fetchAccountInfo());
        const { domainShareList, authAccountType } = res.data.data;
        if (Array.isArray(domainShareList)) {
            const domainShareMap = Object.fromEntries(domainShareList.map(item => [item.orgId, item.domain]));
            this.storeApi.setUserProp('domainShareList', domainShareMap, true);
            return domainShareMap;
        }
        if (typeof authAccountType === 'number') {
            this.storeApi.setUserProp('authAccountType', authAccountType + '');
        }
        return {};
    }
    async getAccountWinInfosFromMainProcess(query) {
        console.log(query);
        return [];
    }
    getAccountWinInfos(query) {
        console.log(query);
        return [];
    }
    async doGetMailAliasAccountListV2({ noMain = false, showProxyEmails = false, email = '' } = {}) {
        const isSubAccount = !!email;
        if (this.isSyncAccountInfo && !isSubAccount) {
            return new Promise((res, rej) => {
                this.requestAccountInfoList.push((data) => {
                    if (data) {
                        res(data);
                    }
                    rej(new Error('request error'));
                });
            });
        }
        const currentUser = this.systemApi.getCurrentUser(email);
        const mainAccount = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        let _defaultSender;
        if (!isCorpMail) {
            _defaultSender = await this.mailConfigApi.getDefaultSendingAccount(email);
        }
        if (!isSubAccount) {
            this.isSyncAccountInfo = true;
        }
        return this.fetchAccountInfo(email)
            .then(res => {
            const isCorpMail = this.systemApi.getIsCorpMailMode();
            if (isCorpMail) {
                corpMailTransformResponse(res);
            }
            const data = res.data;
            return data;
        })
            .then(async (res) => {
            var _a;
            const { aliasList = [], domainList = [], domainLogo = '', popAccountList = [], accountName = '', email = '', nickName = '', senderName = '', defaultSender, qiyeAccountId, domainShareList, node, authAccountType, iconVO, } = res.data || {};
            if (Array.isArray(domainShareList)) {
                const domainShareMap = domainShareList.map(item => [item.orgId, item.domain]);
                this.storeApi.setUserProp('domainShareList', Object.fromEntries(domainShareMap), false, email);
                this.storeApi.setUserProp('companyId', `org_${((_a = res.data) === null || _a === void 0 ? void 0 : _a.orgId) || 0}`, false, email);
            }
            if (Array.isArray(domainList)) {
                this.storeApi.setUserProp('domainList', domainList, false, email);
            }
            if (currentUser && iconVO && iconVO.smallUrl !== currentUser.avatar) {
                currentUser.avatar = iconVO.smallUrl || '';
                this.storeApi.setLastAccount(currentUser, isSubAccount ? email : undefined);
            }
            if (node) {
                this.storeApi.setCurrentNode(node, isSubAccount ? email : undefined);
            }
            if (qiyeAccountId) {
                this.storeApi.setUserProp('contactId', qiyeAccountId + '', false, email);
            }
            if (typeof authAccountType === 'number') {
                this.storeApi.setUserProp('authAccountType', authAccountType + '', false, email);
            }
            if (domainLogo) {
                this.storeApi.setUserProp('domainLogo', domainLogo, false, email);
            }
            const defaultAliasList = !aliasList
                ? []
                : aliasList.map(alias => {
                    var _a, _b;
                    return ({
                        id: alias === null || alias === void 0 ? void 0 : alias.email,
                        name: ((_a = alias === null || alias === void 0 ? void 0 : alias.email) === null || _a === void 0 ? void 0 : _a.split('@')[0]) || '',
                        domain: ((_b = alias === null || alias === void 0 ? void 0 : alias.email) === null || _b === void 0 ? void 0 : _b.split('@')[1]) || '',
                        nickName: alias === null || alias === void 0 ? void 0 : alias.nickName,
                        senderName: alias === null || alias === void 0 ? void 0 : alias.senderName,
                        isMainEmail: (alias === null || alias === void 0 ? void 0 : alias.email) === email,
                        isDefault: (alias === null || alias === void 0 ? void 0 : alias.email) === (defaultSender === null || defaultSender === void 0 ? void 0 : defaultSender.email),
                        mailEmail: email,
                    });
                });
            const domainAliasList = !domainList
                ? []
                : domainList
                    .map(domain => ({
                    id: `${accountName}@${domain}`,
                    name: accountName || nickName,
                    domain,
                    senderName,
                    isMainEmail: `${accountName}@${domain}` === email,
                    isDefault: (defaultSender === null || defaultSender === void 0 ? void 0 : defaultSender.email) === `${accountName}@${domain}`,
                    mailEmail: email,
                    nickName,
                }));
            const popoAliasList = !popAccountList
                ? []
                : popAccountList === null || popAccountList === void 0 ? void 0 : popAccountList.map(({ email, nickName, senderName = '' }) => ({
                    id: email,
                    name: nickName,
                    domain: email === null || email === void 0 ? void 0 : email.split('@')[1],
                    isProxy: true,
                    nickName,
                    senderName,
                    isMainEmail: false,
                    mailEmail: email,
                    isDefault: email === _defaultSender,
                }));
            const _result = showProxyEmails ? [...defaultAliasList, ...domainAliasList, ...popoAliasList] : [...defaultAliasList, ...domainAliasList];
            let result = _result
                .sort((a, b) => (a.isDefault ? -1 : b.isDefault ? 1 : 0))
                .reduce((acc, item) => {
                if (acc.some(_item => _item.id === item.id)) {
                    return acc;
                }
                return [...acc, item];
            }, []);
            if (isCorpMail) {
                const currentUser = this.systemApi.getCurrentUser();
                const hasMainAccount = !!result.find(item => item.id === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id));
                if (!hasMainAccount) {
                    result.push({
                        nickName: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.nickName) || (currentUser === null || currentUser === void 0 ? void 0 : currentUser.accountName) || accountName,
                        name: accountName,
                        id: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
                        domain: currentUser === null || currentUser === void 0 ? void 0 : currentUser.domain,
                    });
                }
            }
            this.storeApi.setUserProp('accountAlias', result.filter(info => !info.isProxy).map(info => info.id), true, email);
            if (noMain) {
                result = result.filter(aliasInfo => aliasInfo.id !== mainAccount);
            }
            if (!isSubAccount) {
                this.isSyncAccountInfo = false;
                this.requestAccountInfoList.forEach(_callback => {
                    _callback(result);
                });
            }
            return result;
        })
            .catch(err => {
            console.error(err);
            if (!isSubAccount) {
                this.isSyncAccountInfo = false;
                this.requestAccountInfoList.forEach(_callback => {
                    _callback(undefined);
                });
            }
            return [];
        });
    }
    async doAddAlias(aliasName, email) {
        var _a, _b;
        const currentEmail = email || ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id);
        const url = this.systemApi.getUrl('addAlias');
        const sid = this.getSid(currentEmail);
        const res = await this.httpApi.get(url, { sid, alias_name: aliasName }, email ? { _account: currentEmail } : {});
        return ((_b = res) === null || _b === void 0 ? void 0 : _b.data) || { code: -1 };
    }
    async doGetAddAliasRight(email) {
        var _a, _b, _c;
        const url = this.systemApi.getUrl('getAccountRight');
        try {
            const res = await this.httpApi.get(url, { right_no: 'add_alias' }, email ? { _account: email } : {});
            return ((_c = (_b = (_a = res) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.data) || false;
        }
        catch (_d) {
            return false;
        }
    }
    async fetchAccountInfo(emailStr) {
        var _a;
        const nowTime = new Date().getTime();
        const email = emailStr || ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id);
        const url = this.systemApi.getUrl('getAccountInfo');
        const sid = this.getSid(email);
        const res = await this.httpApi.get(url, { sid, needUnitNamePath: false }, emailStr ? { _account: email } : {});
        const key = email || lodashGet(res, 'data.data.email', '');
        accountInfoCache[key] = {
            updateTime: nowTime,
            data: res,
        };
        return res;
    }
    getEmail() {
        const user = this.systemApi.getCurrentUser();
        return user === null || user === void 0 ? void 0 : user.id;
    }
    getBindAccounts(params) {
        console.log(params);
        return [];
    }
    init() {
        const accountItemFilter = (item, param) => {
            var _a, _b, _c, _d, _e, _f;
            if (!(param === null || param === void 0 ? void 0 : param.additionalData) || !param.additionalData.mobile || !param.additionalData.accountId) {
                return false;
            }
            if (((_a = param === null || param === void 0 ? void 0 : param.additionalData) === null || _a === void 0 ? void 0 : _a.type) === 'mobile') {
                return item.type === 'mobile' && item.mobile === ((_b = param === null || param === void 0 ? void 0 : param.additionalData) === null || _b === void 0 ? void 0 : _b.mobile);
            }
            if (((_c = param === null || param === void 0 ? void 0 : param.additionalData) === null || _c === void 0 ? void 0 : _c.type) === 'alias') {
                return item.type === 'alias' && item.accountId === ((_d = param === null || param === void 0 ? void 0 : param.additionalData) === null || _d === void 0 ? void 0 : _d.accountId);
            }
            if (item.type === 'mobile') {
                return this.doGetMobileAndArea(item.mobile).mobile === this.doGetMobileAndArea((_e = param === null || param === void 0 ? void 0 : param.additionalData) === null || _e === void 0 ? void 0 : _e.mobile).mobile;
            }
            if (item.type === 'alias') {
                return item.accountId === ((_f = param === null || param === void 0 ? void 0 : param.additionalData) === null || _f === void 0 ? void 0 : _f.accountId);
            }
            return false;
        };
        this.DBApi.addFilterRegistry({
            filterFunc: accountItemFilter,
            name: accountItemFilterName,
        });
        this.eventApi.registerSysEventObserver('updateUserInfo', {
            name: 'loginChangeAccountOb',
            func: async () => {
                const user = this.systemApi.getCurrentUser();
                if (user) {
                    await this.doSaveCurrentAccount(user);
                    this.eventApi.sendSimpleSysEvent('accountNotify');
                }
            },
        });
        this.eventApi.registerSysEventObserver('initModule', {
            name: 'initModuleOb',
            func: ev => {
                ev.eventStrData && this.initModule.add(ev.eventStrData);
            },
        });
        this.updateLocalSubAccountsCache();
        this.handleSubAccountDeleted();
        this.handleSubAccountDBChanged();
        const isMainPage = this.systemApi.isMainPage();
        if (isMainPage) {
            this.eventApi.registerSysEventObserver('sharedAccountLogout', {
                name: 'accountapi-sharedAccountLogout',
                func: ev => {
                    if (!ev || !ev.eventData)
                        return;
                    const email = ev.eventData.id;
                    this.handleSharedAccountLogout(email);
                },
            });
        }
        if (isMainPage || process.env.BUILD_ISWEB) {
            this.eventApi.registerSysEventObserver('SubAccountAdded', {
                name: 'accountapi-SubAccountAdded',
                func: ev => {
                    setTimeout(() => {
                        if (!ev || !ev.eventData)
                            return;
                        const { subAccount } = ev.eventData;
                        if (subAccount) {
                            this.doGetMailAliasAccountListV2({
                                email: subAccount,
                            });
                        }
                    }, 0);
                },
            });
        }
        return this.name;
    }
    handleSubAccountDBChanged() {
        const events = ['subAccountDBChanged', 'SubAccountDeleted', 'SubAccountWindowReady'];
        events.forEach(eventName => {
            this.eventApi.registerSysEventObserver(eventName, {
                name: 'accountApi-' + eventName,
                func: _ => {
                    this.updateLocalSubAccountsCache();
                },
            });
        });
    }
    handleSubAccountDeleted() {
        if (this.systemApi.isMainPage() || (window && window.isBridgeWorker)) {
            this.eventApi.registerSysEventObserver('SubAccountDeleted', {
                name: 'accountApi-handleSubAccountDeleted',
                func: ev => {
                    if (ev && ev.eventData) {
                        const { subAccount } = ev.eventData;
                        const accountMD5 = this.systemApi.md5(subAccount, true);
                        this.DBApi.removeAccountAction(accountMD5);
                        this._ownDomainSetCache.delete(subAccount);
                        this._ownDomainSetInflight.delete(subAccount);
                    }
                },
            });
        }
    }
    async updateSidebarDockUnreadStatus(accountList, isUnread) {
        if (this.systemApi.getCurrentUser() && this.systemApi.isMainWindow()) {
            const accountStoreData = await this.storeApi.getFromDB(APP_SIDEBAR_DOCK_ACCOUNT_LIST, { noneUserRelated: true });
            let list = {};
            try {
                if (accountStoreData && accountStoreData.suc && accountStoreData.data) {
                    list = JSON.parse(accountStoreData.data) || {};
                }
                accountList.forEach(accountId => {
                    list[accountId] = isUnread;
                });
                this.sideBarDockAccountList = Object.assign(Object.assign({}, this.sideBarDockAccountList), list);
                this.storeApi.putToDB(APP_SIDEBAR_DOCK_ACCOUNT_LIST, JSON.stringify(list), { noneUserRelated: true });
            }
            catch (error) {
                console.warn('updateSidebarDockUnreadStatus parse error', error);
            }
        }
    }
    async getSidebarDockAccountList(cached = true) {
        try {
            if (cached && Object.keys(this.sideBarDockAccountList).length > 0) {
                return Object.assign({}, this.sideBarDockAccountList);
            }
            const accountStoreData = await this.storeApi.getFromDB(APP_SIDEBAR_DOCK_ACCOUNT_LIST, { noneUserRelated: true });
            if (accountStoreData && accountStoreData.suc && accountStoreData.data) {
                const res = JSON.parse(accountStoreData.data) || {};
                Object.keys(res).forEach(key => {
                    this.sideBarDockAccountList[key] = res[key];
                });
            }
            else {
                this.storeApi.putToDB(APP_SIDEBAR_DOCK_ACCOUNT_LIST, JSON.stringify({}), { noneUserRelated: true });
            }
            return Object.assign({}, this.sideBarDockAccountList);
        }
        catch (error) {
            console.warn('getSidebarDockAccountList parse error', error);
            return {};
        }
    }
    afterInit() {
        if (this.systemApi.getCurrentUser() && this.systemApi.isMainPage()) {
            this.productAuthApi.saveAuthConfigFromNet();
        }
        if (this.systemApi.getCurrentUser() && !process.env.BUILD_ISPREVIEWPAGE) {
            this.doGetAccountBindInfo().then(() => {
                this.updateServerMobileList();
            });
            this.updateSidebarDockUnreadStatus([this.systemApi.getCurrentUser().id], false);
            this.getServerDomainList().then(({ success, data }) => {
                if (success && data) {
                    this.currentDomainList = data;
                }
            });
        }
        if (!process.env.BUILD_ISPREVIEWPAGE) {
            this.updateLocalSubAccountsCache();
        }
        console.warn('[register_impl] afterInit');
        return this.name;
    }
    afterLogin() {
        return this.name;
    }
    beforeLogout() {
        return this.name;
    }
    async updateServerAliasList() {
        try {
            const current = this.systemApi.getCurrentUser();
            const aliasMobileList = await this.doGetMailAliasAccountListV2({
                noMain: false,
                showProxyEmails: true,
            });
            const list = this.transAlias(aliasMobileList, current.id);
            const { deleteDiff } = await this.checkAccountInfoListDiff(list, 'alias');
            await Promise.all([this.doDeleteAccountInfoList(deleteDiff), this.storeAccountInfoList(list)]);
            this.eventApi.sendSimpleSysEvent('accountNotify');
        }
        catch (e) {
            console.error('[account_impl] updateServerAliasList error', e);
        }
    }
    async updateServerMobileList() {
        try {
            const mobileList = await this.getServerMobileBindAccountList();
            const accountInfoList = this.transMobile(mobileList);
            const { deleteDiff } = await this.checkAccountInfoListDiff(accountInfoList, 'mobile');
            await this.doDeleteAccountInfoList(deleteDiff);
            await this.storeAccountInfoList(accountInfoList);
            this.eventApi.sendSimpleSysEvent('accountNotify');
        }
        catch (e) {
            console.error('[account_impl] updateServerMobileList error', e);
        }
    }
    async doGetAccountIsAdmin() {
        var _a;
        try {
            if (this.cache.isAccount !== undefined) {
                return Promise.resolve(this.cache.isAccount);
            }
            const isCorpMail = this.systemApi.getIsCorpMailMode();
            if (isCorpMail) {
                this.cache.isAccount = false;
                return Promise.resolve(false);
            }
            const url = this.systemApi.getUrl('getIsAdmin');
            const res = await this.httpApi.post(url, Object.assign({}, defaultParams), {
                headers: Object.assign({}, defaultHeader),
                timeout: 20 * 1000,
            });
            const { code = '', result } = res.data || {};
            if (String(code) === '200' && result) {
                const isAccount = Boolean((_a = result.data) === null || _a === void 0 ? void 0 : _a.admin);
                this.cache.isAccount = isAccount;
                return isAccount;
            }
            console.error('[account_impl] doGetAccountIsAdmin error', code, result);
            return false;
        }
        catch (e) {
            console.error('[account_impl] doGetAccountIsAdmin error', e);
            return false;
        }
    }
    async doGetAccountIsNewAccount() {
        try {
            if (!process.env.BUILD_ISEDM) {
                return false;
            }
            const url = this.systemApi.getUrl('getIsNewAccount');
            const res = await this.httpApi.get(url);
            const { success, data } = res.data || {};
            if (success && data) {
                return Boolean(data === null || data === void 0 ? void 0 : data.newAccount);
            }
            console.error('[account_impl] doGetAccountIsNewAccount error', success, data);
            return false;
        }
        catch (e) {
            console.error('[account_impl] doGetAccountIsNewAccount error', e);
            return false;
        }
    }
    async doGetAccountBindAndForwardInfo(_account) {
        const url = this.systemApi.getUrl('getBindAndForwardInfo', undefined, undefined, _account);
        const res = await this.httpApi.post(url, Object.assign({}, defaultParams), {
            headers: Object.assign({}, defaultHeader),
            timeout: 20 * 1000,
            _account,
        });
        const { code = '', result, error } = res.data || {};
        if (String(code) === '200' && result) {
            return result;
        }
        return {
            error: error || 'otherError',
        };
    }
    async doSendVerificationCode(_account) {
        const url = this.systemApi.getUrl('sendVerificationCode', undefined, undefined, _account);
        const res = await this.httpApi.post(url, Object.assign({}, defaultParams), {
            headers: Object.assign({}, defaultHeader),
            timeout: 20 * 1000,
            _account,
        });
        const { code = '', result, error } = res.data || {};
        if (String(code) === '200' && result) {
            return {
                success: true,
                result,
            };
        }
        return {
            success: false,
            error: error || '验证码获取失败，请稍后再试',
        };
    }
    async doCheckVerificationCode(vcode, _account) {
        const url = this.systemApi.getUrl('checkVerificationCode', undefined, undefined, _account);
        const res = await this.httpApi.get(url, {
            vcode,
        }, {
            headers: Object.assign({}, defaultHeader),
            contentType: 'json',
            _account,
        });
        const { code = '', result, error } = res.data || {};
        if (String(code) === '200' && result) {
            return {
                success: true,
                result,
            };
        }
        return {
            success: false,
            error: error || 'otherError',
        };
    }
    async doGetAccountBindInfo() {
        if (!this.systemApi.getCurrentUser()) {
            return '';
        }
        try {
            const url = this.systemApi.getUrl('getBindInfo');
            const res = await this.httpApi.post(url, Object.assign({}, defaultParams), {
                headers: Object.assign({}, defaultHeader),
                timeout: 20 * 1000,
            });
            const { code = '', result, error } = res.data || {};
            if (String(code) === '200' && result) {
                const { mobile, mobile_login_enable: enabledMobileLogin, mobile_login_time: lastLoginTime = 0 } = (result === null || result === void 0 ? void 0 : result.bindInfo) || {};
                mobile &&
                    (await this.updateCurrentAccount({
                        mobile,
                        lastLoginTime,
                        enabledMobileLogin,
                    }));
                return mobile;
            }
            console.error('[account_impl] doGetAccountBindInfo error', code, result);
            return error || 'otherError';
        }
        catch (e) {
            console.error('[account_impl] doGetAccountBindInfo error', e);
            return 'otherError';
        }
    }
    async getServerMobileBindAccountList() {
        try {
            const url = this.systemApi.getUrl('getBindAccountList');
            const bjUrl = this.systemApi.getUrl('getBJBindAccountList');
            const user = this.systemApi.getCurrentUser();
            const [res, bjRes] = await Promise.all([
                this.httpApi.post(url, Object.assign(Object.assign({}, defaultParams), { mobile: user === null || user === void 0 ? void 0 : user.mobile }), {
                    headers: Object.assign({}, defaultHeader),
                    timeout: 20 * 1000,
                }),
                this.httpApi.post(bjUrl, Object.assign(Object.assign({}, defaultParams), { mobile: user === null || user === void 0 ? void 0 : user.mobile }), {
                    headers: Object.assign({}, defaultHeader),
                    timeout: 20 * 1000,
                }),
            ]);
            const { code = '', result } = res.data || {};
            const { code: bjcode = '', result: bjResult } = bjRes.data || {};
            if ((String(code) === '200' && result) || (String(bjcode) === '200' && bjResult)) {
                return [...((result === null || result === void 0 ? void 0 : result.data) || []), ...((bjResult === null || bjResult === void 0 ? void 0 : bjResult.data) || [])];
            }
            console.error('[account_impl] getServerMobileBindAccountList error', code, result, bjcode, bjResult);
            return [];
        }
        catch (e) {
            console.error('[account_impl] getServerMobileBindAccountList error', e);
            return [];
        }
    }
    async checkAccountInfoListDiff(newInfoList, type) {
        const oldInfoList = await this.getStoreAccountInfoList(type);
        const oldList = util.getKeyListByList(oldInfoList, 'id', true);
        const newList = util.getKeyListByList(newInfoList, 'id', true);
        return util.getDiff(oldList, newList);
    }
    doGetAllAccountList() {
        const tableName = this.getAccountTableName();
        return Promise.all([
            this.DBApi.getByEqCondition({
                dbName: this.dbName,
                tableName,
            }),
            this.DBApi.getByEqCondition({
                dbName: this.dbName,
                tableName: this.infoTableName,
            }),
        ]);
    }
    storeAccountList(params) {
        const noSharedAccounts = params && params.length ? params.filter(item => !item.isSharedAccount) : [];
        if (!noSharedAccounts || !noSharedAccounts.length) {
            return Promise.resolve([]);
        }
        const tableName = this.getAccountTableName();
        return this.DBApi.putAll({
            dbName: this.dbName,
            tableName,
        }, noSharedAccounts);
    }
    storeAccountInfoList(params) {
        return this.DBApi.putAll({
            dbName: this.dbName,
            tableName: this.infoTableName,
        }, params);
    }
    async doDeleteAccountList(params) {
        if (!params.length) {
            return true;
        }
        try {
            await this.DBApi.deleteById({
                dbName: this.dbName,
                tableName: this.tableName,
            }, params);
        }
        catch (e) {
            console.error('[account] db delete:', params, e);
            return false;
        }
        return true;
    }
    doDeleteAccountInfoList(params) {
        return this.DBApi.deleteById({
            dbName: this.dbName,
            tableName: this.infoTableName,
        }, params);
    }
    getAccountTableName(isSubAccount) {
        if (typeof isSubAccount !== 'undefined') {
            return isSubAccount ? this.subAccountTableName : this.tableName;
        }
        const isAccountBg = !!(window && window.isAccountBg);
        return isAccountBg ? this.subAccountTableName : this.tableName;
    }
    async getStoreAccountList() {
        try {
            const tableName = this.getAccountTableName();
            const [accountList, infoList] = await Promise.all([
                this.DBApi.getByEqCondition({
                    dbName: this.dbName,
                    tableName,
                }),
                this.getStoreAccountInfoList(),
            ]);
            const sharedAccountInfo = await this.getSharedAccountsInfoAsync();
            return this.transModal(accountList, infoList, sharedAccountInfo);
        }
        catch (e) {
            console.error('[account_impl] getStoreAccountList error', e);
            return Promise.reject(e);
        }
    }
    async getStoreAccountInfoList(type) {
        const current = this.systemApi.getCurrentUser();
        if (!current) {
            return [];
        }
        const { mobile, id: accountId } = current;
        const list = await this.DBApi.getByEqCondition({
            dbName: this.dbName,
            tableName: this.infoTableName,
            additionalData: {
                mobile,
                accountId,
                type,
            },
            filter: [accountItemFilterName],
        });
        return list;
    }
    transModal(accountList, infoList, sharedAccountInfo) {
        const accountInfoList = infoList;
        const current = this.systemApi.getCurrentUser();
        let localList = this.orderByLastLoginTime(accountList);
        let mobileList = [];
        let showMobileList = true;
        const aliasList = [];
        if (current) {
            accountInfoList.forEach(item => {
                if (item.type === 'alias' && !item.isDefault) {
                    aliasList.push(item);
                }
                else if (item.type === 'mobile') {
                    if ((current === null || current === void 0 ? void 0 : current.id) === item.accountId) {
                        current.enabledMobileLogin = item.enabledMobileLogin;
                        current.lastLoginTime = item.lastLoginTime || 0;
                        if (!(current.enabledMobileLogin && current.lastLoginTime > 0)) {
                            showMobileList = false;
                            mobileList = [];
                        }
                    }
                    if (showMobileList && !accountList.some(account => account.id === item.accountId)) {
                        mobileList.push(item);
                    }
                }
            });
            localList = localList
                .filter(item => item.id !== current.id && !aliasList.some(alias => alias.accountId === item.id))
                .filter(item => {
                if (!sharedAccountInfo) {
                    return true;
                }
                if (sharedAccountInfo.isSharedAccountLogin) {
                    if (item.id === sharedAccountInfo.email) {
                        return false;
                    }
                }
                return true;
            });
            mobileList = this.orderByLastLoginTime(mobileList);
        }
        return cloneDeep({
            current,
            localList,
            mobileList,
            aliasList,
        });
    }
    transAlias(list, accountId) {
        return list.map(item => {
            const { name, id, domain, isProxy, isDefault } = item;
            return {
                id: util.getUnique(accountId, 'alias', name, domain),
                originId: id,
                accountId,
                type: 'alias',
                domain,
                accountName: name,
                isDefault,
                isProxy,
                updateTime: new Date().getTime(),
            };
        });
    }
    transMobile(list) {
        const accountInfoList = [];
        list.forEach(item => {
            const { account_id, domain, account_name, mobile, mobile_login_time, mobile_login_enable, status } = item;
            const accountId = this.doGetAccount({
                accountName: account_name,
                domain,
            });
            accountInfoList.push({
                id: util.getUnique(accountId, 'mobile', mobile),
                accountId,
                originId: account_id,
                type: 'mobile',
                mobile,
                status,
                enabledMobileLogin: mobile_login_enable,
                lastLoginTime: mobile_login_time,
                updateTime: new Date().getTime(),
            });
        });
        return accountInfoList;
    }
    transUser(user) {
        const { id, avatar, lastLoginTime, originId, mobile } = user;
        let infoList;
        const isSubAccount = !!user.isSubAccount;
        if (!isSubAccount) {
            if (mobile) {
                infoList = {
                    id: util.getUnique(id, 'mobile', mobile),
                    accountId: id,
                    type: 'mobile',
                    originId,
                    mobile,
                    avatar,
                    lastLoginTime,
                    enabledMobileLogin: true,
                    updateTime: new Date().getTime(),
                };
            }
        }
        return {
            accountList: cloneDeep(user),
            infoList,
        };
    }
    testPwdStyleIsNew(pwd) {
        return pwd.startsWith(this.encryptedPwdHead) && pwd.endsWith(this.encryptedPwdTail);
    }
    decryptByKey(pwd) {
        const newPwd = pwd.replace(this.encryptedPwdHead, '').replace(this.encryptedPwdTail, '');
        return this.systemApi.decryptByKey(newPwd, this.storeApi.getUUID());
    }
    transStorageAccount(list) {
        return list.map(({ a, k, lastLogin, t, tExpire, mobile, user }) => {
            let pwd = '';
            if (k) {
                if (this.testPwdStyleIsNew(k)) {
                    const pwdTxt = this.decryptByKey(k);
                    pwd = this.systemApi.md5(pwdTxt);
                }
                else {
                    pwd = k;
                }
            }
            let account;
            if (user) {
                account = Object.assign(Object.assign({}, user), { lastLoginTime: lastLogin, pwd });
            }
            else {
                const { account: accountName, domain } = this.systemApi.handleAccountAndDomain(a);
                account = {
                    id: a,
                    pwd,
                    accountName,
                    domain,
                    accountMd5: this.systemApi.md5(a, true),
                    company: '',
                    nickName: '',
                    avatar: '',
                    refreshToken: t,
                    refreshTokenExpire: tExpire,
                    mobile,
                    lastLoginTime: lastLogin,
                    sessionId: '',
                };
            }
            return account;
        });
    }
    async doUpdateAccountList(list) {
        const idList = util.getKeyListByList(list, 'id', true);
        const accountList = await this.doGetAccountInfo(idList);
        const accountMap = util.listToMap(accountList, 'id');
        const storeList = list.map(item => (Object.assign(Object.assign({}, (accountMap[item.id] || {})), item)));
        return this.storeAccountList(storeList);
    }
    doGetAccount(params) {
        const { accountName, domain } = params;
        if (!accountName || !domain) {
            console.error('accountName domain cannot be none');
            return '';
        }
        return accountName + '@' + domain;
    }
    doGetMobileAndArea(mobile) {
        if (!mobile) {
            return {
                mobile: '',
                mobileArea: '',
            };
        }
        if (mobile.indexOf(')') === -1) {
            return {
                mobile,
                mobileArea: '86',
            };
        }
        const arr = mobile.split(')');
        return {
            mobile: arr[1],
            mobileArea: arr[0].slice(1),
        };
    }
    doGetMobileAccountInfo(id) {
        return this.DBApi.getByEqCondition({
            dbName: this.dbName,
            tableName: this.infoTableName,
            query: {
                id,
            },
        });
    }
    async doGetAllMainAndSubAccounts() {
        const mainAccounts = (await this.doGetAccountInfo()) || [];
        const subAccounts = (await this.getSubAccounts({ expired: false })) || [];
        return subAccounts.concat(mainAccounts);
    }
    async doGetAccountInfo(idList, isSubAccount = false) {
        try {
            let adCondition;
            const tableName = this.getAccountTableName(isSubAccount);
            const currentUser = this.systemApi.getCurrentUser();
            if (idList && idList.length) {
                if (isSubAccount) {
                    if (currentUser) {
                        adCondition = {
                            type: 'anyOf',
                            args: [idList.map(idStr => [currentUser.id, idStr])],
                            field: '[mainAccount+id]',
                        };
                    }
                    else {
                        return [];
                    }
                }
                else {
                    adCondition = {
                        type: 'anyOf',
                        args: [idList],
                        field: 'id',
                    };
                }
            }
            return this.DBApi.getByRangeCondition({
                dbName: this.dbName,
                tableName,
                adCondition,
            });
        }
        catch (e) {
            console.error('[contact_impl] doGetAccountInfo error', e);
            return [];
        }
    }
    async doGetAccountInfoById(id, isSubAccount) {
        try {
            let adCondition;
            const tableName = this.getAccountTableName(isSubAccount);
            if (isSubAccount) {
                const currentUser = this.systemApi.getCurrentUser();
                if (currentUser) {
                    adCondition = {
                        type: 'anyOf',
                        args: [[currentUser.id, id]],
                        field: '[mainAccount+id]',
                    };
                }
                else {
                    return undefined;
                }
            }
            else {
                adCondition = {
                    type: 'anyOf',
                    args: [id],
                    field: 'id',
                };
            }
            const res = await this.DBApi.getByRangeCondition({
                dbName: this.dbName,
                tableName,
                adCondition,
            });
            return res[0];
        }
        catch (e) {
            console.error('[contact_impl] doGetAccountInfoById error', e);
        }
        return undefined;
    }
    getIsAccountBg() {
        return inWindow() ? window && window.isAccountBg : false;
    }
    async doSaveCurrentAccount(user) {
        var _a;
        try {
            const { isSubAccount } = user;
            const subAccountEmailId = isSubAccount ? user.id : '';
            const saveUser = Object.assign(Object.assign({}, user), ((subAccountEmailId ? AccountApiImp.subAccountIsSaveCurrentUserMap[subAccountEmailId] : AccountApiImp.isSaveCurrentUser) || {}));
            if (!isSubAccount) {
                AccountApiImp.isSaveCurrentUser = saveUser;
            }
            else {
                AccountApiImp.subAccountIsSaveCurrentUserMap[subAccountEmailId] = saveUser;
            }
            const { accountList, infoList } = this.transUser(saveUser);
            const arr = [];
            if (isSubAccount && !accountList.mainAccount) {
                if (accountList) {
                    const mainAccountEmail = (_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id;
                    if (mainAccountEmail) {
                        accountList.mainAccount = mainAccountEmail;
                    }
                }
            }
            if (accountList.mainAccount) {
                arr.push(this.addOrUpdateLocalSubAccounts([accountList]));
            }
            else {
                arr.push(this.doUpdateAccountList([accountList]));
            }
            if (infoList) {
                arr.push(this.storeAccountInfoList([infoList]));
            }
            await Promise.all(arr);
            if (!isSubAccount) {
                AccountApiImp.isSaveCurrentUser = undefined;
            }
            else {
                AccountApiImp.subAccountIsSaveCurrentUserMap[subAccountEmailId] = undefined;
            }
            console.log('doSaveCurrentAccount success');
            return {
                success: true,
            };
        }
        catch (e) {
            return {
                success: false,
                message: e.message,
            };
        }
    }
    async doGetAccountList(isCache = true) {
        try {
            const isCorpMail = this.systemApi.getIsCorpMailMode();
            const current = this.systemApi.getCurrentUser();
            if (!isCache && !isCorpMail && current) {
                current.mobile && this.updateServerMobileList().then();
                this.updateServerAliasList().then();
            }
            const res = await this.getStoreAccountList();
            if (!this.systemApi.isElectron() && res) {
                res.mobileList = [];
            }
            return res;
        }
        catch (e) {
            console.error('[account_impl] doGetAccountList error', e);
            return Promise.reject(e);
        }
    }
    doTransMobileBindAccountList(list) {
        try {
            return list.map(item => {
                const { domain, account_name, status, token, mobile_login_enable, mobile_login_time, mobile, account_exp, area, nickname, shared } = item;
                return {
                    domain,
                    accountName: account_name,
                    status,
                    expired: account_exp,
                    enabledMobileLogin: mobile_login_enable,
                    lastLoginTime: mobile_login_time,
                    nickName: nickname,
                    token,
                    mobile,
                    area,
                    shared,
                };
            });
        }
        catch (e) {
            console.error('[account_impl] doTransMobileBindAccountList error', e);
            return [];
        }
    }
    async doCleanAllAccount() {
        try {
            const data = await this.doGetAccountList();
            const localList = util.getKeyListByList(data.localList, 'id', true);
            if (data.current) {
                localList.push(data.current.id);
            }
            const mobileList = util.getKeyListByList(data.mobileList, 'id', true);
            await Promise.all([this.doDeleteAccountList(localList), this.doDeleteAccountInfoList(mobileList)]);
            return {
                success: true,
            };
        }
        catch (e) {
            return {
                success: false,
                message: '清除失败',
            };
        }
    }
    async doGetVerifyCode(mobile, isCancel) {
        try {
            const url = this.httpApi.buildUrl(this.systemApi.getUrl(isCancel ? 'getCancelVerifyCode' : 'getVerifyCode'), Object.assign(Object.assign({}, defaultParams), { mobile }));
            const { data } = await this.httpApi.post(url, {}, {
                headers: Object.assign({}, defaultHeader),
            });
            return {
                success: String(data === null || data === void 0 ? void 0 : data.code) === '200',
                message: data === null || data === void 0 ? void 0 : data.error,
            };
        }
        catch (e) {
            return {
                success: false,
                message: e.message,
            };
        }
    }
    updateCurrentAccount(params) {
        const user = this.systemApi.getCurrentUser();
        const current = Object.assign(user, params);
        return Promise.all([this.storeApi.setLastAccount(current), this.doSaveCurrentAccount(current)]);
    }
    async doBindMobile(code, mobile) {
        try {
            const url = this.httpApi.buildUrl(this.systemApi.getUrl('bindMobile'), Object.assign(Object.assign({}, defaultParams), { code }));
            const { data } = await this.httpApi.post(url, Object.assign({}, defaultParams), {
                headers: Object.assign({}, defaultHeader),
            });
            if (String(data === null || data === void 0 ? void 0 : data.code) === '200') {
                await this.updateCurrentAccount({ mobile });
                return {
                    success: true,
                };
            }
            return {
                success: false,
                message: ErrMsgCodeMap[data === null || data === void 0 ? void 0 : data.error] || (data === null || data === void 0 ? void 0 : data.error),
            };
        }
        catch (e) {
            console.error('[account_impl] doUnBindMobile error', e);
            return {
                success: false,
                message: e.message,
            };
        }
    }
    async doUpdateBindMobile(code, mobile) {
        try {
            const url = this.httpApi.buildUrl(this.systemApi.getUrl('updateBindMobile'), Object.assign(Object.assign({}, defaultParams), { code }));
            const { data } = await this.httpApi.post(url, Object.assign({}, defaultParams), {
                headers: Object.assign({}, defaultHeader),
            });
            if (String(data === null || data === void 0 ? void 0 : data.code) === '200') {
                await this.updateCurrentAccount({ mobile });
                return {
                    success: true,
                };
            }
            return {
                success: false,
                message: ErrMsgCodeMap[data === null || data === void 0 ? void 0 : data.error] || (data === null || data === void 0 ? void 0 : data.error),
            };
        }
        catch (e) {
            console.error('[account_impl] doUnBindMobile error', e);
            return {
                success: false,
                message: e.message,
            };
        }
    }
    async doGetSecLevelEntry(params) {
        try {
            const url = this.httpApi.buildUrl(this.systemApi.getUrl('getSecLevelEntry'), Object.assign({}, defaultParams));
            const { data } = await this.httpApi.post(url, Object.assign(Object.assign({}, defaultParams), params), { headers: Object.assign({}, defaultHeader) });
            const { code, result } = data;
            if (code !== 200) {
                throw new Error('获取安全等级失败');
            }
            return result === null || result === void 0 ? void 0 : result.data;
        }
        catch (e) {
            throw new Error('获取安全等级失败');
        }
    }
    async doUnBindMobile(code) {
        try {
            const url = this.httpApi.buildUrl(this.systemApi.getUrl('unbindMobile'), Object.assign(Object.assign({}, defaultParams), { code }));
            const { data } = await this.httpApi.post(url, Object.assign({}, defaultParams), {
                headers: Object.assign({}, defaultHeader),
            });
            if (String(data === null || data === void 0 ? void 0 : data.code) === '200') {
                await this.removeCurrentMobile();
                return {
                    success: true,
                };
            }
            return {
                success: false,
                message: ErrMsgCodeMap[data === null || data === void 0 ? void 0 : data.error] || ((data === null || data === void 0 ? void 0 : data.error) === 'ERR.FORBIDDEN' ? '账号开启了二次验证，无法解绑手机号' : data === null || data === void 0 ? void 0 : data.error),
            };
        }
        catch (e) {
            console.error('[account_impl] doUnBindMobile error', e);
            return {
                success: false,
                message: e.message,
            };
        }
    }
    doSaveStorageAccount(list) {
        console.log('[account] save login ', list);
        const accountList = this.transStorageAccount(list);
        return this.storeAccountList(accountList);
    }
    async removeCurrentMobile() {
        const user = this.systemApi.getCurrentUser();
        try {
            if (user === null || user === void 0 ? void 0 : user.mobile) {
                const current = Object.assign(Object.assign({}, user), { mobile: undefined });
                const mobileId = this.getMobileAccountInfoId(user);
                await Promise.all([this.storeApi.setLastAccount(current), this.doSaveCurrentAccount(current), this.doDeleteAccountInfoList([mobileId])]);
            }
        }
        catch (e) {
            console.error('[account_impl removeCurrentMobile error]', e);
        }
    }
    async getCurrentAccountInfo(emailAddress, account) {
        const url = this.systemApi.getUrl('getYunxinInfoByEmail');
        return this.fetchAccountAndToken(url, {
            emailList: emailAddress,
            account: account || '',
        });
    }
    async fetchAccountAndToken(remoteUrl, params) {
        const properties = this.systemApi.handleAccountAndDomain(params.emailList);
        const subAccount = params.account || '';
        const apiResponse = await this.httpApi.get(remoteUrl, {
            domain: properties.domain,
            emailList: params.emailList,
        }, {
            _account: subAccount,
        });
        const retryFunc = async (retry) => {
            var _a;
            const { data: res } = apiResponse;
            if (!res || String(res.code) !== '200' || !res.data) {
                console.error('getYunxinInfoByEmail Failed:', apiResponse);
            }
            else {
                const accountList = (((_a = res.data) === null || _a === void 0 ? void 0 : _a.itemList) || []).filter(item => item.status === 0);
                if (accountList.length) {
                    return accountList[0];
                }
            }
            await wait(1000 * retry + 500);
            if (retry < 3) {
                return retryFunc(retry + 1);
            }
            if (!subAccount) {
                this.eventApi.sendSysEvent({
                    eventName: 'error',
                    eventLevel: 'error',
                    eventStrData: '',
                    eventData: {
                        popupType: 'toast',
                        popupLevel: 'error',
                        title: ErrMsgCodeMap.IM_AUTH_FAIL,
                        code: 'IM_AUTH_FAIL',
                    },
                    eventSeq: 0,
                });
            }
            return Promise.reject(new Error('超过重试次数'));
        };
        return retryFunc(0);
    }
    getMobileAccountInfoId(user) {
        return util.getUnique(user.id, 'mobile', user.mobile);
    }
    orderByLastLoginTime(data) {
        if ((data === null || data === void 0 ? void 0 : data.length) > 1) {
            data.sort((a, b) => {
                if (a === null || a === void 0 ? void 0 : a.lastLoginTime) {
                    return (b === null || b === void 0 ? void 0 : b.lastLoginTime) ? -(a.lastLoginTime - b.lastLoginTime) : -1;
                }
                return (b === null || b === void 0 ? void 0 : b.lastLoginTime) ? 1 : 0;
            });
        }
        return data;
    }
    async doUpdateAccountRefreshToken() {
        const currentUser = this.systemApi.getCurrentUser();
        if (!currentUser || !process.env.BUILD_ISELECTRON) {
            return;
        }
        const now = Date.now();
        const { domain, accountName, refreshTokenExpire: tokenExpire = 0, refreshToken = '' } = currentUser;
        if (tokenExpire - now <= 3 * 24 * 60 * 60 * 1000) {
            const { success } = await this.loginApi.doUpdateRefreshToken({
                account_name: accountName,
                domain,
                tokenExpire,
                token: refreshToken,
            });
            this.performanceApi.point({
                statKey: 'update_refreshToken',
                statSubKey: success ? 'success' : 'fail',
                value: 1,
                valueType: 4,
            });
        }
    }
    async transDomainList(list) {
        const orgId = await this.getCurrentOrgId();
        if (orgId) {
            return list.map(item => ({
                id: util.getUnique(orgId, item.domain),
                orgId,
                domain: item.domain,
                type: item.type === undefined ? -1 : item.type,
            }));
        }
        return [];
    }
    storeDomainList(params) {
        return this.DBApi.putAll({
            dbName: this.dbName,
            tableName: this.domainTableName,
        }, params);
    }
    async getServerDomainList() {
        var _a;
        try {
            const { data } = await this.httpApi.get(this.systemApi.getUrl('getDomainListByOrg'));
            if ((data === null || data === void 0 ? void 0 : data.success) && ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.domainList)) {
                const domainList = await this.transDomainList(data.data.domainList);
                await this.storeDomainList(domainList);
                return {
                    success: true,
                    data: domainList,
                };
            }
            return {
                success: false,
            };
        }
        catch (e) {
            console.error('[account_impl] getServerDomainList error', e);
            return {
                success: false,
                message: e.message,
            };
        }
    }
    async getCurrentOrg() {
        const list = await this.contactApi.doGetOrgList({ typeList: [99] });
        return list[0];
    }
    async getCurrentOrgId() {
        const org = await this.getCurrentOrg();
        return org === null || org === void 0 ? void 0 : org.originId;
    }
    doGetEmailInCurrentDomain(email) {
        const { domain } = this.systemApi.handleAccountAndDomain(email);
        return this.currentDomainList.some(item => item.domain === domain);
    }
    async doGetDomainList() {
        const id = await this.getCurrentOrgId();
        if (!id) {
            return [];
        }
        const domainList = (await this.DBApi.getByEqCondition({
            dbName: this.dbName,
            tableName: this.domainTableName,
            query: {
                orgId: id,
            },
        }));
        this.currentDomainList = domainList;
        return domainList;
    }
    doGetInitModule() {
        return this.initModule;
    }
    putSubAccounts(models) {
        return this.DBApi.putAll({
            dbName: this.dbName,
            tableName: this.subAccountTableName,
        }, models);
    }
    async deleteLocalSubAccounts(query) {
        try {
            const deleteCondition = this.getSubAccountQueryConfig(query);
            await this.DBApi.deleteByByRangeCondition(deleteCondition);
            this.updateLocalSubAccountsCache();
            return true;
        }
        catch (ex) {
            console.error('deleteSubAccounts error', ex);
            return false;
        }
    }
    deleteAllSubAccountDB(email) {
        if (!email || !email.length)
            return;
        const dbNames = ['catalog_dexie', 'contact_dexie', 'fileop', 'mail_new', 'task_mail'];
        const emailMD5 = this.systemApi.md5(email, true);
        dbNames.forEach(dbName => {
            const accountDbName = dbName + '_' + emailMD5;
            this.DBApi.deleteDB(accountDbName);
        });
    }
    async addOrUpdateLocalSubAccounts(models) {
        if (!models || !models.length)
            return [];
        const query = {
            dbName: this.dbName,
            tableName: this.subAccountTableName,
        };
        const subAccounts = await this.DBApi.getByRangeCondition(query);
        if (subAccounts && subAccounts.length) {
            models.forEach((model, inx) => {
                const existedSubAccount = subAccounts.find(item => item.id === model.id && item.mainAccount === model.mainAccount);
                if (model.rowId) {
                    delete model.rowId;
                }
                if (existedSubAccount) {
                    models[inx] = Object.assign(Object.assign({}, existedSubAccount), model);
                }
            });
        }
        const res = await this.putSubAccounts(models);
        setTimeout(() => {
            this.updateLocalSubAccountsCache();
        }, 10);
        return res;
    }
    getSubAccountQueryConfig(query) {
        const queryConfig = {
            dbName: this.dbName,
            tableName: this.subAccountTableName,
        };
        if (!query || !query.mainAccountEmail) {
            const currentUser = this.systemApi.getCurrentUser();
            const mainAccountEmail = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
            if (!query) {
                query = { mainAccountEmail };
            }
            if (!query.mainAccountEmail) {
                query.mainAccountEmail = mainAccountEmail;
            }
        }
        if (query) {
            if (query.mainAccountEmail && query.subAccountEmail) {
                queryConfig.adCondition = {
                    field: '[mainAccount+id]',
                    type: 'equals',
                    args: [[query.mainAccountEmail, query.subAccountEmail]],
                };
            }
            else if (query.mainAccountEmail) {
                queryConfig.adCondition = {
                    field: 'mainAccount',
                    type: 'equals',
                    args: [query.mainAccountEmail],
                };
            }
            else if (query.subAccountEmail) {
                queryConfig.adCondition = {
                    field: 'id',
                    type: 'equals',
                    args: [query.subAccountEmail],
                };
            }
        }
        return queryConfig;
    }
    async getMainAndSubAccounts(query) {
        const currentUser = this.systemApi.getCurrentUser();
        if (!currentUser)
            return [];
        const subAccounts = await this.getSubAccounts(query);
        const currentAccount = Object.assign(Object.assign({ accountType: 'mainAccount' }, currentUser), { emailType: 'NeteaseQiYeMail', mainAccount: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id, expired: false, agentEmail: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id });
        subAccounts.unshift(currentAccount);
        return subAccounts;
    }
    getLocalSubAccountsFromCache(query) {
        const subAccounts = subAccountsCache || [];
        if (!subAccounts || !(subAccounts === null || subAccounts === void 0 ? void 0 : subAccounts.length))
            return [];
        return subAccounts
            .filter(item => {
            let mainAccountParam = query && query.mainAccountEmail ? query.mainAccountEmail : '';
            if (!mainAccountParam) {
                const currentUser = this.systemApi.getCurrentUser();
                mainAccountParam = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
            }
            return item.mainAccount === mainAccountParam;
        })
            .filter(item => {
            const subAccountId = query && query.subAccountEmail ? query.subAccountEmail : '';
            if (!subAccountId)
                return true;
            return subAccountId === item.agentEmail || item.id === subAccountId;
        })
            .filter(item => {
            const expired = query && typeof query.expired !== 'undefined' ? query.expired : '';
            if (expired === '') {
                return true;
            }
            return item.expired === expired;
        });
    }
    getIsSameSubAccountSync(email1, email2) {
        var _a, _b;
        if (window.isAccountBg) {
            return true;
        }
        if (!email1 && !email2) {
            return true;
        }
        let email1Real = email1;
        if (!email1) {
            email1Real = (_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id;
        }
        let email2Real = email2;
        if (!email2) {
            email2Real = (_b = this.systemApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.id;
        }
        if ((!email1 && email2) || (!email2 && email1)) {
            return email2Real === email1Real;
        }
        if (email1 && email2 && email1 === email2) {
            return true;
        }
        const email2InCache = subAccountIdToAgentCache[email1Real];
        return email2Real === email2InCache;
    }
    getSubAccountInfo(name) {
        try {
            const subAccounts = subAccountsCache;
            if (!subAccounts || !subAccounts.length)
                return null;
            const targetAccount = subAccounts.find(item => item.id === name || item.agentEmail === name);
            if (targetAccount) {
                return targetAccount;
            }
        }
        catch (ex) {
            console.error('[Errorf]getSubAccountInfo', ex);
        }
        return null;
    }
    async updateLocalSubAccountsCache() {
        try {
            subAccountsCache = await this.getSubAccounts();
            subAccountIdToAgentCache = {};
            if (subAccountsCache && subAccountsCache.length) {
                subAccountsCache.forEach(subAccount => {
                    if (subAccount.id) {
                        subAccountIdToAgentCache[subAccount.id] = subAccount.agentEmail || subAccount.id;
                        if (subAccount.agentEmail && subAccount.id !== subAccount.agentEmail) {
                            subAccountIdToAgentCache[subAccount.agentEmail] = subAccount.id || subAccount.agentEmail;
                        }
                    }
                });
            }
        }
        catch (ex) {
            console.error('updateLocalSubAccountsCache-error', ex);
        }
    }
    getSubAccountSid(email) {
        try {
            const subAccounts = subAccountsCache;
            if (!subAccounts || !subAccounts.length)
                return '';
            const targetAccount = subAccounts.find(item => item.id === email || item.agentEmail === email);
            if (targetAccount) {
                return targetAccount.sessionId;
            }
            return '';
        }
        catch (ex) {
            console.error('getSubAccountSid-error', ex);
            return '';
        }
    }
    getNodeInfoByEmail(email, _account) {
        const defaultNode = '';
        try {
            if (_account) {
                const node = this.storeApi.getCurrentNode(_account);
                return node;
            }
            const subAccounts = subAccountsCache;
            if (!subAccounts || !subAccounts.length)
                return defaultNode;
            const targetAccount = subAccounts.find(item => item.id === email || item.agentEmail === email);
            if (targetAccount) {
                return targetAccount.node || defaultNode;
            }
            return defaultNode;
        }
        catch (ex) {
            console.error('getNodeInfoByEmail-error', ex);
            return defaultNode;
        }
    }
    addEmailTypeToSubAccount(item) {
        var _a, _b;
        try {
            if (item) {
                if (item.emailType)
                    return;
                if (item.accountType === 'qyEmail' || item.accountType === 'mainAccount') {
                    item.emailType = 'NeteaseQiYeMail';
                    return;
                }
                const { agentEmail } = item;
                if (agentEmail) {
                    const emailDomain = agentEmail.split('@')[1];
                    switch (emailDomain) {
                        case 'qq.com':
                            item.emailType = 'QQMail';
                            break;
                        case '163.com':
                            item.emailType = '163Mail';
                            break;
                        case '126.com':
                            item.emailType = '126Mail';
                            break;
                        case 'gmail.com':
                            item.emailType = 'Gmail';
                            break;
                        case 'outlook.com':
                            item.emailType = 'Outlook';
                            break;
                        default:
                            if ((_b = (_a = item) === null || _a === void 0 ? void 0 : _a.sendHost) === null || _b === void 0 ? void 0 : _b.endsWith('exmail.qq.com')) {
                                item.emailType = 'TencentQiye';
                            }
                            else {
                                item.emailType = 'Others';
                            }
                            break;
                    }
                }
            }
        }
        catch (ex) {
            console.error(ex);
        }
    }
    async getSubAccounts(query) {
        const queryConfig = this.getSubAccountQueryConfig(query);
        const result = await this.DBApi.getByRangeCondition(queryConfig);
        let retResult = result;
        if (query && typeof query.expired !== 'undefined') {
            retResult = result.filter(item => item.expired === query.expired);
        }
        retResult.forEach(item => {
            this.addEmailTypeToSubAccount(item);
            if (!item.expired) {
                const subAccountEmailId = this.storeApi.getEmailIdByEmail(item.id);
                if (!subAccountEmailId) {
                    item.expired = true;
                }
                else {
                    const subAccountUser = this.systemApi.getCurrentUser(subAccountEmailId);
                    if (!subAccountUser) {
                        item.expired = true;
                    }
                }
            }
        });
        return retResult;
    }
    async deleteBindAccount(account) {
        var _a;
        try {
            if (!account || !account.email || !account.agentEmail) {
                return this.getParamErrorResult();
            }
            const { email, agentEmail } = account;
            const { accountType } = account;
            let url = '';
            if (accountType === 'qyEmail' || accountType === 'personalEmail') {
                url = this.systemApi.getUrl('deleteSubAccount');
            }
            else {
                return {
                    success: false,
                    errMsg: '不支持的账号类型',
                    errCode: 200,
                };
            }
            if (email && email.includes('.third.') && email !== agentEmail) {
                try {
                    await this.mailApi.cleanPushConfig(email);
                }
                catch (ex) {
                    console.error('cleanPushConfig-catch', ex);
                }
            }
            const res = await this.httpApi.post(url, { email: agentEmail, relationType: accountType === 'qyEmail' ? 0 : 1 }, { headers: defaultHeader }).then(res => res.data);
            if (((_a = res === null || res === void 0 ? void 0 : res.code) === null || _a === void 0 ? void 0 : _a.toString()) === '200') {
                const currentUser = this.systemApi.getCurrentUser();
                await this.deleteLocalSubAccounts({
                    mainAccountEmail: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
                    subAccountEmail: email,
                });
                await this.deleteSubAccountLocalStateByEmail(email);
                this.sendSubAccountDeletedEvent(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id, email, agentEmail);
                return {
                    success: true,
                };
            }
            return {
                success: false,
                errMsg: res === null || res === void 0 ? void 0 : res.err_msg,
                errCode: res === null || res === void 0 ? void 0 : res.errorCode,
            };
        }
        catch (ex) {
            return {
                success: false,
                errMsg: ex.message,
                errCode: 'deleteBindAccount-catch',
            };
        }
    }
    getCurrentAccount() {
        return { email: '' };
    }
    setCurrentAccount(param) {
        console.log(param);
    }
    async getAllSubAccounts() {
        const currentUser = this.systemApi.getCurrentUser();
        if (!currentUser)
            return [];
        const subAccountsFromServer = (await this.getBindAccountsFromServer()) || [];
        const localSubAccounts = await this.getSubAccounts({
            mainAccountEmail: currentUser.id,
        });
        subAccountsFromServer.forEach(item => {
            var _a;
            const isQyEmail = item.accountType === 'qyEmail';
            const itemEmail = isQyEmail ? item.accountEmail : item.accountEmail;
            const localItem = localSubAccounts.find(item => item.id === itemEmail);
            item.password = isQyEmail ? '' : localItem ? ((_a = localItem.mainSendReceiveInfo) === null || _a === void 0 ? void 0 : _a.password) || '' : '';
            item.expired = localItem ? localItem.expired : true;
            this.addEmailTypeToSubAccount(item);
        });
        return subAccountsFromServer;
    }
    async isSubAccount(email) {
        const allSubAccounts = await this.getSubAccounts({
            expired: false,
        });
        const findRes = allSubAccounts.find(item => item.id === email);
        return !!findRes;
    }
    async getAllBindAccountsFromServer() {
        var _a, _b;
        try {
            const currentUser = this.systemApi.getCurrentUser();
            const url = this.systemApi.getUrl('getSubAccountList');
            const res = await this.httpApi.post(url, {}, { headers: defaultHeader }).then(res => res.data);
            if (((_a = res === null || res === void 0 ? void 0 : res.code) === null || _a === void 0 ? void 0 : _a.toString()) === '200') {
                const serverList = (((_b = res === null || res === void 0 ? void 0 : res.result) === null || _b === void 0 ? void 0 : _b.data) || []);
                return serverList
                    .map(item => {
                    let res = null;
                    if (item.relationType === 1) {
                        res = {
                            accountType: 'personalEmail',
                            accountEmail: item.account_name + '@' + item.domain,
                            mainAccount: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
                            accountName: item.account_name,
                            domain: item.domain,
                            agentEmail: item.agent_email,
                            agentNickname: item.agent_nickname,
                            sendHost: item.send_host,
                            sendPort: item.send_port,
                            sendSsl: item.send_ssl,
                            receivePort: item.receive_port,
                            receiveHost: item.receive_host,
                            receiveSsl: item.receive_ssl,
                            verified: !!item.verified,
                        };
                    }
                    else if (item.relationType === 0) {
                        const accountInfo = this.systemApi.handleAccountAndDomain(item.email || '');
                        res = {
                            accountType: 'qyEmail',
                            agentEmail: item.email,
                            mainAccount: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
                            accountName: accountInfo.account,
                            domain: accountInfo.domain,
                            accountEmail: item.email,
                            emailType: 'NeteaseQiYeMail',
                            verified: !!item.verified,
                        };
                    }
                    if (res) {
                        this.addEmailTypeToSubAccount(res);
                    }
                    return res || {};
                })
                    .filter(item => item.accountType && item.accountEmail);
            }
            return null;
        }
        catch (ex) {
            return null;
        }
    }
    async getBindAccountsFromServer() {
        try {
            return this.getAllBindAccountsFromServer().then(res => {
                if (res === null)
                    return null;
                return res;
            });
        }
        catch (ex) {
            console.error('getBindAccountsFromServer error', ex);
            return null;
        }
    }
    async getPersonalBindAccountsFromServer() {
        try {
            return this.getAllBindAccountsFromServer().then(res => {
                if (!res)
                    return null;
                return res.filter(item => item.accountType === 'personalEmail');
            });
            return null;
        }
        catch (ex) {
            return null;
        }
    }
    async editSubAccount(param) {
        try {
            const { accountType } = param;
            let editResult;
            if (accountType === 'personalEmail') {
                editResult = await this.editPersonSubAccount(param);
                if (editResult.success) {
                    const bindParam = Object.assign(Object.assign({}, param), { password: param.password, agentEmail: param.agentEmail, accountType: 'Others', isEditMode: true });
                    const currentUser = this.systemApi.getCurrentUser();
                    const subAccounts = await this.getSubAccounts({
                        mainAccountEmail: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
                        subAccountEmail: param.accountEmail,
                    });
                    const targetSubAccount = subAccounts.find(item => item.mainSendReceiveInfo && item.mainSendReceiveInfo.agentEmail === param.agentEmail);
                    if (targetSubAccount) {
                        targetSubAccount.mainSendReceiveInfo = Object.assign(Object.assign({}, targetSubAccount.mainSendReceiveInfo), param);
                        targetSubAccount.nickName = param.agentNickname;
                        targetSubAccount.expired = false;
                        await this.addOrUpdateLocalSubAccounts([targetSubAccount]);
                    }
                    editResult = await this.loginApi.bindSubAccount(bindParam);
                }
            }
            else if (accountType === 'qyEmail') {
                editResult = await this.editQiyeMailSubAccount(param);
            }
            else {
                return {
                    success: false,
                    errCode: 100,
                    errMsg: '不支持的账号类型',
                };
            }
            return editResult;
        }
        catch (ex) {
            return {
                success: false,
                errMsg: ex.message,
                errCode: 'editSubAccounts-error',
            };
        }
    }
    async editQiyeMailSubAccount(param) {
        try {
            const email = param.agentEmail;
            const password = param.password;
            if (!email || !password) {
                return this.getParamErrorResult();
            }
            return await this.loginApi.bindSubAccount({
                accountType: 'NeteaseQiYeMail',
                agentEmail: email,
                password,
                isEditMode: true,
            });
        }
        catch (ex) {
            return {
                success: false,
                errCode: 'editQiyeMailSubAccount-catch',
                errMsg: ex.message,
            };
        }
    }
    async editPersonSubAccount(param) {
        var _a;
        try {
            let url = this.systemApi.getUrl('updateSubAccount');
            let data = {
                current_email: param.agentEmail,
                email: param.agentEmail,
                password: param.password,
                send_host: param.sendHost,
                send_port: param.sendPort,
                send_ssl: param.sendSsl,
                receive_host: param.receiveHost,
                receive_port: param.receivePort,
                receive_ssl: param.receiveSsl,
                agent_nickname: param.agentNickname,
                relationType: 1,
            };
            if (param.updateSubAccountNickname) {
                url = this.systemApi.getUrl('updateSubAccountNickname');
                data = {
                    agent_nickname: param.agentNickname,
                    agent_email: param.agentEmail,
                };
            }
            const res = await this.httpApi.post(url, data, { headers: defaultHeader }).then(res => res.data);
            if (((_a = res === null || res === void 0 ? void 0 : res.code) === null || _a === void 0 ? void 0 : _a.toString()) === '200') {
                return {
                    success: true,
                };
            }
            const errorCode = res === null || res === void 0 ? void 0 : res.errorCode;
            return {
                success: false,
                errCode: res === null || res === void 0 ? void 0 : res.errorCode,
                errMsg: SUB_ACCOUNT_ERRCODE_MAPS[errorCode] || (res === null || res === void 0 ? void 0 : res.err_msg),
            };
        }
        catch (ex) {
            return {
                success: false,
                errCode: 'editPersonSubAccount-catch',
                errMsg: ex.message,
            };
        }
    }
    async createSubAccountWin(info) {
        try {
            const { mainAccountEmail, subAccountEmail, sessionName, eventName, agentEmail, param, eventData } = info;
            const sessionNameUsed = sessionName || `persist:${mainAccountEmail}-${subAccountEmail}`;
            const urlParams = Object.assign({ 'open-account-bg-page': 'true', 'main-account': mainAccountEmail, 'sub-account': subAccountEmail, 'agent-account': agentEmail, sessionName: sessionNameUsed }, (param || {}));
            const SUB_ACCOUNT_TYPE = 'subAccountBg';
            const createWinReq = {
                type: SUB_ACCOUNT_TYPE,
                additionalParams: urlParams,
                manualShow: true,
                sessionName: sessionNameUsed,
            };
            let winRes;
            if (eventName) {
                const commonEventData = { sessionName: sessionNameUsed };
                winRes = await this.systemApi.createWindowWithInitData(createWinReq, {
                    eventName,
                    eventData: eventData ? Object.assign(Object.assign({}, commonEventData), eventData) : commonEventData,
                });
            }
            else {
                winRes = await this.systemApi.createWindow(createWinReq);
            }
            return winRes;
        }
        catch (ex) {
            console.error('doCreateSubAccountWin-error', ex);
            return undefined;
        }
    }
    sendSubAccountDeletedEvent(mainEmail, subEmail, agentEmail) {
        this.eventApi.sendSysEvent({
            eventName: 'SubAccountDeleted',
            eventData: {
                mainAccount: mainEmail,
                subAccount: subEmail,
                agentEmail,
            },
        });
    }
    async deleteLocalSubAccountsByServerAccounts(subAccountsFromServer, localSubAccounts) {
        try {
            if (isDeleteingLocalSubAccounts)
                return;
            if (!localSubAccounts || !localSubAccounts.length)
                return;
            if (subAccountsFromServer === null) {
                return;
            }
            const currentUser = this.systemApi.getCurrentUser();
            if (!currentUser)
                return;
            isDeleteingLocalSubAccounts = true;
            const deleteEmails = [];
            const emailToAgentEmail = {};
            localSubAccounts.forEach(item => {
                if (item.accountType === 'mainAccount')
                    return;
                if (!subAccountsFromServer || !subAccountsFromServer.length) {
                    deleteEmails.push(item.id);
                    emailToAgentEmail[item.id] = item.agentEmail || '';
                    return;
                }
                const subAccountInServer = subAccountsFromServer.find(serverItem => {
                    if (serverItem.accountType === 'qyEmail') {
                        return serverItem.accountEmail === item.id;
                    }
                    if (serverItem.accountType === 'personalEmail') {
                        return serverItem.accountEmail === item.id && serverItem.agentEmail === item.agentEmail;
                    }
                    return false;
                });
                if (!subAccountInServer) {
                    deleteEmails.push(item.id);
                    emailToAgentEmail[item.id] = item.agentEmail || '';
                }
            });
            if (deleteEmails && deleteEmails.length) {
                await Promise.allSettled(deleteEmails.map(email => {
                    this.deleteSubAccountLocalStateByEmail(email).then(res => {
                        if (res) {
                            const agentEmail = emailToAgentEmail[email];
                            if (agentEmail) {
                                this.sendSubAccountDeletedEvent(currentUser.id, email, agentEmail);
                            }
                        }
                    });
                }));
            }
            isDeleteingLocalSubAccounts = false;
        }
        catch (ex) {
            isDeleteingLocalSubAccounts = true;
            console.error('deleteLocalSubAccountsByServerAccounts-error', ex);
        }
    }
    async initDeleteLocalSubAccounts() {
        try {
            const currentUser = this.systemApi.getCurrentUser();
            if (!currentUser)
                return;
            const localSubAccounts = await this.getSubAccounts({
                mainAccountEmail: currentUser.id,
            });
            const subAccountsFromServer = await this.getBindAccountsFromServer();
            this.deleteLocalSubAccountsByServerAccounts(subAccountsFromServer, localSubAccounts);
        }
        catch (ex) {
            console.error('deleteLocalSubAccounts-error', ex);
        }
    }
    deleteSubAccountLocalStateByEmail(email) {
        try {
            this.deleteAllSubAccountDB(email);
            const emailMD5 = this.systemApi.md5(email, true);
            this.DBApi.removeAccountAction(emailMD5);
            this._ownDomainSetCache.delete(email);
            this._ownDomainSetInflight.delete(email);
            this.removeSubAccountFromStore(email);
            return this.deleteLocalSubAccounts({ subAccountEmail: email });
        }
        catch (ex) {
            console.error('deleteSubAccountByEmail-catch', ex);
            return Promise.resolve(false);
        }
    }
    sendSubAccountExpiredEvent(eventData) {
        this.eventApi.sendSysEvent({
            eventName: 'SubAccountLoginExpired',
            eventData: eventData || {},
        });
    }
    async closeAllSubAccountWindows() {
        try {
            if (!window || !window.electronLib) {
                return;
            }
            const allWinInfos = await window.electronLib.windowManage.getAllWinInfo();
            const subAccountWins = allWinInfos.filter(winItem => winItem.type === 'subAccountBg');
            subAccountWins.forEach(winItem => {
                const winId = winItem.id;
                this.systemApi.closeSubWindow(winId, true, false);
            });
        }
        catch (ex) {
            console.error('closeAllSubAccountWindows-catch', ex);
        }
    }
    async subAccountLoginPreExpiredHandle(val) {
        const { mainAccount = '', subAccount = '', agentEmail = '' } = val;
        const subAccounts = await this.getSubAccounts({
            mainAccountEmail: mainAccount,
            subAccountEmail: subAccount,
        });
        subAccounts.forEach(item => {
            item.expired = true;
        });
        await this.addOrUpdateLocalSubAccounts(subAccounts);
        this.removeSubAccountFromStore(subAccount);
        this.sendSubAccountExpiredEvent(val);
        this.sendSubAccountExpiredToServer(mainAccount, agentEmail);
    }
    sendSubAccountSyncLoginFailed(subAccount) {
        this.eventApi.sendSysEvent({
            eventName: 'subAccountSyncLoginFailed',
            eventData: {
                agentEmail: subAccount.agentEmail,
                email: subAccount.accountType === 'qyEmail' ? subAccount.accountEmail : subAccount.agentEmail,
            },
        });
        this.dataTrackApi.track('subAccount_syncLogin_failed', { email: subAccount.agentEmail, accountType: subAccount.accountType });
    }
    async subAccountSyncLogin(subAccount) {
        try {
            if (loginingMailMap.has(subAccount.agentEmail)) {
                return;
            }
            loginingMailMap.set(subAccount.agentEmail, true);
            const result = await this.loginApi.syncSubAccountLoginStatus(subAccount);
            if (!result.success) {
                this.sendSubAccountSyncLoginFailed(subAccount);
            }
            else {
                this.dataTrackApi.track('subAccount_syncLogin_success', { email: subAccount.agentEmail, accountType: subAccount.accountType });
            }
            setTimeout(() => {
                loginingMailMap.delete(subAccount.agentEmail);
            }, 2000);
            return result;
        }
        catch (ex) {
            console.error('subAccountSyncLogin-error', ex);
            this.sendSubAccountSyncLoginFailed(subAccount);
        }
    }
    async updateSubAccountVerified(subAccounts) {
        try {
            if (!subAccounts || !subAccounts.length)
                return;
            const noVerfiedSubAccounts = subAccounts.filter(subAccount => !subAccount.verified && !subAccount.expired && subAccount.accountType === 'qyEmail');
            if (noVerfiedSubAccounts && noVerfiedSubAccounts.length) {
                noVerfiedSubAccounts.forEach(subAccount => {
                    this.loginApi.updateQiyeMailSubAccount(subAccount.accountEmail || '');
                });
            }
        }
        catch (ex) {
            console.error('updateSubAccountVerified-error', ex);
        }
    }
    async subAccountsSyncLogin(subAccounts) {
        try {
            if (!subAccounts || !subAccounts.length)
                return;
            const currentUser = this.systemApi.getCurrentUser();
            if (currentUser) {
                const allSubAccounts = subAccounts;
                const expiredSubAccounts = allSubAccounts.filter(accountItem => {
                    const isPersonalEmail = accountItem.accountType === 'personalEmail';
                    if (isPersonalEmail && accountItem.expired) {
                        return true;
                    }
                    if (!isPersonalEmail && accountItem.expired && accountItem.verified) {
                        return true;
                    }
                    return false;
                });
                if (expiredSubAccounts && expiredSubAccounts.length) {
                    this.eventApi.sendSysEvent({
                        eventName: 'subAccountSyncLoginStart',
                        eventData: expiredSubAccounts
                            .filter(subAccount => {
                            if (loginingMailMap.has(subAccount.agentEmail)) {
                                return false;
                            }
                            return true;
                        })
                            .map(subAccount => ({
                            agentEmail: subAccount.agentEmail,
                            email: subAccount.accountType === 'qyEmail' ? subAccount.accountEmail : subAccount.agentEmail,
                        })),
                    });
                    for (let i = 0; i < expiredSubAccounts.length; ++i) {
                        await this.subAccountSyncLogin(expiredSubAccounts[i]);
                    }
                }
            }
        }
        catch (ex) {
            console.error('sync subAccountSyncLogin error', ex);
        }
    }
    async initSubAccountWins() {
        if (this.isSubAccountInited)
            return;
        this.loggerApi.track('initSubAccountWins');
        this.isSubAccountInited = true;
        const isMainPage = this.systemApi.isMainPage();
        if (isMainPage || process.env.BUILD_ISWEB) {
            if (process.env.BUILD_ISWEB) {
                this.sendSyncSubAccountInitEvent();
            }
            const currentUser = this.systemApi.getCurrentUser();
            if (!currentUser)
                return;
            const shouldCreateSubAccountWin = this.getShouldCreateSubAccountWins();
            if (shouldCreateSubAccountWin) {
                await this.closeAllSubAccountWindows();
            }
            await this.initDeleteLocalSubAccounts();
            if (currentUser) {
                const subAccounts = await this.getSubAccounts({
                    mainAccountEmail: currentUser.id,
                    expired: false,
                });
                try {
                    this.acceptSubAccountWinData(subAccounts, currentUser);
                }
                catch (e) {
                    console.error('acceptSubAccountWinData error', e);
                }
                subAccounts.forEach(item => {
                    const eventParam = {
                        mainAccount: currentUser.id,
                        subAccount: item.id,
                        agentEmail: item.agentEmail,
                    };
                    if (shouldCreateSubAccountWin) {
                        this.createSubAccountWin({
                            mainAccountEmail: currentUser.id,
                            agentEmail: item.agentEmail,
                            subAccountEmail: item.id,
                        });
                    }
                    else {
                        this.eventApi.sendSysEvent({
                            eventName: 'SubAccountWindowReady',
                            eventData: eventParam,
                        });
                    }
                });
                if (!shouldCreateSubAccountWin) {
                    const allSubAccounts = await this.getAllSubAccounts();
                    this.subAccountsSyncLogin(allSubAccounts);
                    this.updateSubAccountVerified(allSubAccounts);
                }
            }
            this.eventApi.registerSysEventObserver('SubAccountLoginPreExpired', {
                func: async (ev) => {
                    if (ev && ev.eventData) {
                        const { eventData } = ev;
                        await this.subAccountLoginPreExpiredHandle(eventData);
                    }
                },
            });
        }
    }
    removeSubAccountFromStore(subAccount) {
        this.storeApi.setLastAccount(undefined, subAccount);
        this.storeApi.removeSubAccountFromList(subAccount);
    }
    sendSubAccountExpiredToServer(mainAccountEmail, agentEmail) {
        this.dataTrackApi.track('pcMail_accountFailure_agent', {
            mainAccount: mainAccountEmail,
            agentEmail,
        });
    }
    getParamErrorResult() {
        return {
            success: false,
            errCode: 'Param-Error',
            errMsg: '参数错误',
        };
    }
    getCatchErrorResult(fnName, ex) {
        return {
            success: false,
            errCode: `${fnName}-Catch`,
            errMsg: ex.message,
        };
    }
    async updateLocalNickName(param) {
        const subAccounts = await this.getSubAccounts({
            subAccountEmail: param.email,
        });
        if (subAccounts && subAccounts.length) {
            const subAccount = subAccounts[0];
            subAccount.nickName = param.nickName;
            if (subAccount.mainSendReceiveInfo) {
                subAccount.mainSendReceiveInfo.agentNickname = param.nickName;
            }
            await this.addOrUpdateLocalSubAccounts([subAccount]);
        }
    }
    async editSubAccountNickName(param) {
        try {
            const subAccountEmail = param.email;
            const subAccounts = await this.getSubAccounts({
                subAccountEmail,
                expired: false,
            });
            if (!subAccounts || !subAccounts.length) {
                return {
                    success: true,
                    errMsg: 'SubAccount not exist',
                    errCode: 100,
                };
            }
            const subAccount = subAccounts[0];
            const { accountType } = subAccount;
            let res = null;
            if (accountType === 'personalEmail') {
                subAccount.mainSendReceiveInfo.agentNickname = param.nickName;
                const editParam = Object.assign(subAccount, subAccount.mainSendReceiveInfo || {}, { updateSubAccountNickname: true });
                res = await this.editPersonSubAccount(editParam);
            }
            else if (accountType === 'qyEmail') {
                res = await this.setQiyeMailSubAccoutNickName(param);
            }
            else {
                res = {
                    success: false,
                    errMsg: 'AccountType not support',
                };
            }
            if (res && res.success) {
                await this.updateLocalNickName(param);
            }
            return (res || {
                success: false,
            });
        }
        catch (ex) {
            console.error('editSubAccountNickName-error', ex);
            return {
                success: false,
            };
        }
    }
    async setQiyeMailSubAccoutNickName(param) {
        try {
            if (!param || !param.email || !param.nickName) {
                return this.getParamErrorResult();
            }
            const res = await this.mailConfigApi.setMailSenderName(param.nickName.trim(), param.email);
            if (res) {
                await this.updateLocalNickName(param);
            }
            return {
                success: res,
            };
        }
        catch (ex) {
            return this.getCatchErrorResult('setQiyeMailSubAccoutNickName', ex);
        }
    }
    async getQiyeMailSubAccountNickName(param) {
        try {
            if (!param || !param.email) {
                return this.getParamErrorResult();
            }
            const res = await this.mailConfigApi.getMailSenderInfo(param.email);
            const mainAccounts = res.filter(item => item.isMainEmail);
            if (mainAccounts && mainAccounts.length) {
                const firstMainAccount = mainAccounts[0];
                const senderName = firstMainAccount.senderName;
                return {
                    success: true,
                    data: {
                        nickName: senderName,
                    },
                };
            }
            return {
                success: false,
                errCode: 'no-main-acount',
                errMsg: '获取主账号失败',
            };
        }
        catch (ex) {
            return this.getCatchErrorResult('getQiyeMailSubAccountNickName', ex);
        }
    }
    checkShareAccountExpired(force) {
        const isMainPage = this.systemApi.isMainPage();
        if (!isMainPage)
            return;
        const currentUser = this.systemApi.getCurrentUser();
        if (currentUser === null || currentUser === void 0 ? void 0 : currentUser.isSharedAccount) {
            if (!force) {
                this.getSharedAccountsInfoAsync(true).then(sharedAccountInfo => {
                    if (sharedAccountInfo && !sharedAccountInfo.isSharedAccountLogin) {
                        this.httpApi.triggerCurrentUserLogout(true);
                    }
                });
            }
            else {
                this.httpApi.triggerCurrentUserLogout(true);
            }
        }
    }
    getShouldCreateSubAccountWins() {
        if (!process.env.BUILD_ISELECTRON) {
            return false;
        }
        const res = this.storeApi.getSync(this.subAccountDataCompleteKey);
        if (res && res.suc && res.data === 'false') {
            return false;
        }
        return true;
    }
    setShouldCreateSubAccountWins(val) {
        return this.storeApi.putSync(this.subAccountDataCompleteKey, `${val}`);
    }
    sendSyncSubAccountInitEvent(restartApp) {
        this.eventApi.sendSysEvent({
            eventName: 'initModule',
            eventStrData: 'syncSubAccount',
            eventData: {
                restartApp: !!restartApp,
            },
        });
    }
    acceptSubAccountWinData(subAccounts, currentUser) {
        if (process.env.BUILD_ISWEB)
            return;
        const isMainPage = this.systemApi.isMainPage();
        if (!isMainPage) {
            return;
        }
        const shouldCreateSubAccountWin = this.getShouldCreateSubAccountWins();
        this.loggerApi.track('acceptSubAccountWinData_state', { shouldCreateSubAccountWin, subAccounts });
        if (subAccounts.length <= 0 || !shouldCreateSubAccountWin || !this.systemApi.isElectron() || !currentUser) {
            this.setShouldCreateSubAccountWins(false);
            this.sendSyncSubAccountInitEvent(false);
            return;
        }
        this.subAccounts = subAccounts.map(_ => _.id);
        this.eventApi.registerSysEventObserver('syncSubAccountState', {
            func: async (ev) => {
                this.loggerApi.track('acceptSubAccountWinData_event', { subAccounts: this.subAccounts, ev });
                if (ev && ev.eventData) {
                    if (this.subAccounts.includes(ev.eventData.userId)) {
                        await this.storeApi.putSubAccountState(ev.eventData);
                        this.subAccounts = this.subAccounts.filter(_ => _ !== ev.eventData.userId);
                    }
                }
                if (this.subAccounts.length <= 0) {
                    this.loggerApi.track('acceptSubAccountWinData_event_initModule');
                    this.setShouldCreateSubAccountWins(false);
                    this.syncSubAccountTimer && clearTimeout(this.syncSubAccountTimer);
                    this.syncSubAccountTimer = null;
                    this.sendSyncSubAccountInitEvent(true);
                }
            },
        });
        this.syncSubAccountTimer = setTimeout(async () => {
            this.loggerApi.track('syncSubAccountTimer', { subAccounts: this.subAccounts });
            this.setShouldCreateSubAccountWins(false);
            const allHandle = [];
            for (let i = 0; i < this.subAccounts.length; i++) {
                const subAccountUser = subAccounts.find(_ => _.id === this.subAccounts[i]);
                const val = {
                    mainAccount: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
                    subAccount: subAccountUser === null || subAccountUser === void 0 ? void 0 : subAccountUser.id,
                    agentEmail: subAccountUser === null || subAccountUser === void 0 ? void 0 : subAccountUser.agentEmail,
                };
                allHandle.push(this.subAccountLoginPreExpiredHandle(Object.assign({}, val)));
            }
            await Promise.allSettled(allHandle);
            this.loggerApi.track('syncSubAccountTimer_initModule');
            this.sendSyncSubAccountInitEvent(true);
        }, 10000);
    }
    async sendSubAccountWinData() {
        if (window.isAccountBg) {
            const currentUser = this.systemApi.getCurrentUser();
            if (currentUser) {
                const res = this.storeApi.getSubAccountState();
                this.loggerApi.track('sendSubAccountWinData_getSubAccountState', { res });
                if (res) {
                    const eventData = Object.assign({ userId: currentUser.id }, res);
                    this.eventApi.sendSysEvent({
                        eventName: 'syncSubAccountState',
                        eventData,
                    });
                }
            }
        }
    }
    afterLoadFinish() {
        const isMainPage = this.systemApi.isMainPage();
        if (isMainPage) {
            this.systemApi.intervalEvent(this.updateAccountRefreshTokenHandle);
            setTimeout(() => {
                this.doUpdateAccountRefreshToken();
            }, 60 * 1000);
        }
        try {
            this.doGetMailAliasAccountListV2();
        }
        catch (ex) {
            console.error('doGetMailAliasAccountListV2-error', ex);
        }
        try {
            const ckRes = checkMasterInfo();
            if (!(ckRes === null || ckRes === void 0 ? void 0 : ckRes.isMaster) && process.env.MOCK_ENV !== 'mobile') {
                this.initSubAccountWins();
            }
        }
        catch (ex) {
            console.error('initSubAccountWins-error', ex);
        }
        try {
            this.sendSubAccountWinData();
        }
        catch (e) {
            console.error('sendSubAccountWinData error', e);
        }
        this.checkShareAccountExpired();
        const subAccounts = this.storeApi.getSubAccountList();
        subAccounts.forEach(subAccount => {
            if (subAccount.email) {
                this.doGetMailAliasAccountListV2({ email: subAccount.email });
            }
        });
        return this.name;
    }
    async getIsSharedAccountLoginAsync() {
        try {
            if (sharedAccountInfoCache) {
                return sharedAccountInfoCache.isSharedAccountLogin;
            }
            const sharedAccountInfo = await this.getSharedAccountsInfoAsync(true);
            if (sharedAccountInfo) {
                return sharedAccountInfo.isSharedAccountLogin;
            }
            return false;
        }
        catch (ex) {
            console.error('getIsSharedAccountLoginAsync error', ex);
            return false;
        }
    }
    async getIsSharedAccountAsync() {
        try {
            if (sharedAccountInfoCache) {
                return sharedAccountInfoCache.isSharedAccount;
            }
            const sharedAccountInfo = await this.getSharedAccountsInfoAsync(true);
            if (sharedAccountInfo) {
                return sharedAccountInfo.isSharedAccount;
            }
            return false;
        }
        catch (ex) {
            return false;
        }
    }
    handleSharedAccountLogout(email) {
        if (sharedAccountInfoCache) {
            sharedAccountInfoCache.isSharedAccountLogin = false;
            sharedAccountInfoCache.isSharedAccountExpired = true;
            if (email && sharedAccountInfoCache.sharedAccounts && sharedAccountInfoCache.sharedAccounts.length) {
                sharedAccountInfoCache.sharedAccounts = sharedAccountInfoCache.sharedAccounts.filter(item => item.email !== email);
            }
        }
    }
    async getSharedAccountsInfoAsync(refresh = false) {
        var _a, _b, _c;
        try {
            if (sharedAccountInfoCache && !refresh) {
                return cloneDeep(sharedAccountInfoCache);
            }
            const url = this.systemApi.getUrl('getSharedAccounts');
            const resData = await this.httpApi.post(url).then(res => res.data);
            const resCode = (_a = resData === null || resData === void 0 ? void 0 : resData.code) === null || _a === void 0 ? void 0 : _a.toString();
            if (resCode === '200') {
                const resResult = resData.result;
                const sharedAccounts = (resResult === null || resResult === void 0 ? void 0 : resResult.sharedAccounts) || [];
                const currentUser = this.systemApi.getCurrentUser();
                const currentUserEmail = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) || '';
                let isSharedAccountLogin = false;
                const accounts = sharedAccounts
                    .filter(item => item.enabled)
                    .map(item => {
                    if (item.email === currentUserEmail) {
                        item.isCurrentAccount = true;
                        isSharedAccountLogin = true;
                    }
                    else {
                        item.isCurrentAccount = false;
                    }
                    return item;
                });
                const res = {
                    isSharedAccount: isSharedAccountLogin ? true : (resResult === null || resResult === void 0 ? void 0 : resResult.pub) || false,
                    isSharedAccountExpired: false,
                    email: resResult === null || resResult === void 0 ? void 0 : resResult.email,
                    nickName: resResult === null || resResult === void 0 ? void 0 : resResult.nickName,
                    alias: (resResult === null || resResult === void 0 ? void 0 : resResult.alias) || [],
                    isSharedAccountLogin,
                    sharedAccounts: accounts,
                };
                sharedAccountInfoCache = res;
                if (process.env.BUILD_ISELECTRON) {
                    if (currentUser && currentUser.isSharedAccount) {
                        if (!res.isSharedAccountLogin) {
                            const newRes = {
                                isSharedAccount: true,
                                isSharedAccountExpired: true,
                                email: ((_b = currentUser.originAccount) === null || _b === void 0 ? void 0 : _b.email) || '',
                                nickName: ((_c = currentUser.originAccount) === null || _c === void 0 ? void 0 : _c.nickName) || '',
                                alias: [],
                                isSharedAccountLogin: true,
                                sharedAccounts: [
                                    {
                                        email: res.email,
                                        nickName: res.nickName,
                                        units: [''],
                                        enabled: true,
                                        isCurrentAccount: true,
                                        avatar: '',
                                    },
                                ],
                            };
                            return newRes;
                        }
                    }
                }
                return cloneDeep(res);
            }
            if (resCode === '403') {
                this.checkShareAccountExpired(true);
                return null;
            }
            console.error('getSharedAccountsAsync response error', resData);
            return null;
        }
        catch (ex) {
            console.error('getSharedAccountsAsync catch error', ex);
            return null;
        }
    }
    getSubAccountsEmailType(email) {
        const result = subAccountsCache.find(v => v.id === email || v.agentEmail === email);
        return (result === null || result === void 0 ? void 0 : result.emailType) || 'Others';
    }
    getAccountsEmailType(email) {
        const currentUser = this.systemApi.getCurrentUser();
        if (!currentUser) {
            return 'Others';
        }
        const currentAccount = Object.assign(Object.assign({ accountType: 'mainAccount' }, currentUser), { emailType: 'NeteaseQiYeMail', mainAccount: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id, expired: false, agentEmail: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id });
        const result = [currentAccount, ...subAccountsCache].find(v => v.id === email || v.agentEmail === email);
        return (result === null || result === void 0 ? void 0 : result.emailType) || 'Others';
    }
    getEmailIdByEmail(email, returnExpired) {
        return this.storeApi.getEmailIdByEmail(email, returnExpired);
    }
    getAgentEmailByEmail(email) {
        return this.storeApi.getAgentEmailByEmail(email);
    }
    async sendCosUpgrade(type) {
        try {
            const url = this.systemApi.getUrl('sendCosUpgrade');
            const resData = await this.httpApi
                .post(url, { type }, {
                headers: Object.assign({}, defaultHeader),
            })
                .then(res => res.data);
            if ((resData === null || resData === void 0 ? void 0 : resData.code) === 200 || (resData === null || resData === void 0 ? void 0 : resData.code) === '200') {
                return resData;
            }
            return Promise.reject(new Error('请求失败'));
        }
        catch (e) {
            console.error('[account_impl] sendCosUpgrade error', e);
            return Promise.reject(e);
        }
    }
    async doGetMarkInfo() {
        var _a, _b, _c;
        try {
            const url = this.systemApi.getUrl('getMarkInfo');
            const res = await this.httpApi.get(url);
            if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code) === 200 && ((_c = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.waterMarkAccount)) {
                return res.data.result.waterMarkAccount;
            }
            return Promise.reject((res === null || res === void 0 ? void 0 : res.statusText) || '获取失败');
        }
        catch (e) {
            return Promise.reject(e);
        }
    }
    async doGetOrgInfo() {
        var _a, _b, _c, _d, _e;
        try {
            const url = this.systemApi.getUrl('getOrgInfo');
            const res = await this.httpApi.post(url, null, { headers: Object.assign({}, defaultHeader) });
            if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code) === 200 && ((_c = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.data)) {
                return (_e = (_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.result) === null || _e === void 0 ? void 0 : _e.data;
            }
            return Promise.reject((res === null || res === void 0 ? void 0 : res.statusText) || '获取失败');
        }
        catch (e) {
            return Promise.reject(e);
        }
    }
    async doGetOwnDomainSet(account) {
        const key = account || '__main__';
        const cached = this._ownDomainSetCache.get(key);
        if (cached) {
            return cached;
        }
        const inflight = this._ownDomainSetInflight.get(key);
        if (inflight) {
            return inflight;
        }
        const promise = (async () => {
            var _a;
            try {
                const orgInfo = await this.doGetOrgInfo();
                const domains = ((_a = orgInfo === null || orgInfo === void 0 ? void 0 : orgInfo.domain_list) !== null && _a !== void 0 ? _a : []).map(d => d === null || d === void 0 ? void 0 : d.domain).filter((d) => typeof d === 'string' && d.length > 0);
                const set = new Set(domains);
                this._ownDomainSetCache.set(key, set);
                return set;
            }
            catch (err) {
                console.warn('[account] doGetOwnDomainSet failed, returning empty Set', err);
                return new Set();
            }
            finally {
                this._ownDomainSetInflight.delete(key);
            }
        })();
        this._ownDomainSetInflight.set(key, promise);
        return promise;
    }
    async doGetWebsiteInfo() {
        var _a, _b, _c, _d, _e;
        try {
            const url = this.systemApi.getUrl('getWebsiteInfo');
            const res = await this.httpApi.post(url, null, { headers: defaultHeader });
            if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code) === 200 && ((_c = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.data)) {
                return (_e = (_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.result) === null || _e === void 0 ? void 0 : _e.data;
            }
            return Promise.reject((res === null || res === void 0 ? void 0 : res.statusText) || '获取失败');
        }
        catch (e) {
            return Promise.reject(e);
        }
    }
    async doCreateWebsiteOrder() {
        var _a;
        try {
            const url = this.systemApi.getUrl('createWebsiteOrder');
            const res = await this.httpApi.post(url, null, { headers: defaultHeader });
            if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code) === 200) {
                return true;
            }
        }
        catch (e) {
            console.error('[account_impl] doCreateWebsiteOrder error', e);
        }
        return false;
    }
    async doGetSecCertInfoById(account) {
        const res = await this.DBApi.getByEqCondition({
            dbName: this.dbName,
            tableName: this.secCertTableName,
            query: {
                id: account,
            },
        });
        return res[0];
    }
    async doGetAllSecCertInfoList() {
        try {
            const res = await this.DBApi.getByRangeCondition({
                dbName: this.dbName,
                tableName: this.secCertTableName,
            });
            return res;
        }
        catch (error) {
            console.error('[account_impl] doGetAllSecCertInfoList error', error);
            return [];
        }
    }
    async doSaveSecCertInfo(account, data) {
        try {
            if (!account) {
                return false;
            }
            if (!data) {
                await this.DBApi.deleteById({
                    dbName: this.dbName,
                    tableName: this.secCertTableName,
                }, [account]);
            }
            else {
                await this.DBApi.putAll({
                    dbName: this.dbName,
                    tableName: this.secCertTableName,
                }, [
                    Object.assign(Object.assign({}, data), { id: account }),
                ]);
            }
            return true;
        }
        catch (e) {
            console.error('[account_impl] doSaveSecCertInfo error', e);
            return false;
        }
    }
    async storeAccountSecInfoList(list) {
        try {
            await this.DBApi.putAll({
                dbName: this.dbName,
                tableName: this.secCertTableName,
            }, list);
            return true;
        }
        catch (e) {
            console.error('[account_impl] storeAccountSecInfoList error', e);
            return false;
        }
    }
}
AccountApiImp.subAccountIsSaveCurrentUserMap = {};
AccountApiImp.RndSyncRate = Math.floor(6 * Math.random());
const impl = new AccountApiImp();
api.registerLogicalApi(impl);
export default impl;
